import { toastMessage } from "utils/toastMessage";
import {
  instance as axios,
  setJwtToken,
  setMultiPartHeader,
} from "../../config/axiosInstance";

// ----master-list--delivery-slot/fees----coin-value/award-value----------------------
export const getMasterListApi = async (data) => {
  const endPoint = `admin/master/getAllMasterData` + "?" + new URLSearchParams({ ...data });
  return await axios.get(endPoint, setJwtToken());
};

export const updateDeliveryValueApi = async (data) => {
  const endPoint = `admin/master/update`;
  return await axios.post(endPoint, data, setJwtToken());
};

export const deletedApi = async (data) => {
  const endPoint = `admin/master/delete`;
  return await axios.post(endPoint, data,setJwtToken());
};

export const updateDeliveryStatusApi = async (
  id,
  status,
  value,
  setButtonLoader = () => { },
  modalClose = () => { },
  ApiRefresh = () => { },
  listData,
  setListData,
  setLoadingId = () => { },
  from,
  to,
  type,
) => {
  const payload = {
    id: id,
    ...(status ? { status: status } : {}),
    ...(value && from && to ? { value: value, from: from, to: to, type } : {}),
    ...(value && { value: value }),
  }
  try {
    if (setLoadingId) {
      setLoadingId(id)
    }
    if (setButtonLoader) {
      setButtonLoader(true);
    }
    const res = await updateDeliveryValueApi(payload)

    const { code, message } = res?.data;
    if (code === 200) {
      if (ApiRefresh) {
        ApiRefresh();
      }
      if (status) {
        setListData(listData.map(item => item._id === id ? { ...item, status: status } : item));
      }
      if (modalClose) {
        modalClose();
      } if (value) {
        toastMessage(message, "success", "changeUserStatus");
      }
    }
  } catch (e) {
    console.log("error:", e.error);
  } finally {
    if (setButtonLoader) {
      setButtonLoader(false);
    }
    if (setLoadingId) {
      setLoadingId('')
    }
  }
}


// ---------add-slot---------------
export const addSlotAPi = async (data) => {
  const endPoint = `admin/master/create`;
  return await axios.post(endPoint, data, setJwtToken());
};
// ---------update-slot---------------
export const updateSlotApi = async (data) => {
  const endPoint = `admin/master/update`;
  return await axios.post(endPoint, data, setJwtToken());
};